import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Submission } from 'src/app/model/paper';

/**
 * `<app-submission-header>` — cabeçalho monolítico da submissão. Passo 4 da
 * migração pra `<app-submission-export-view>`. Engloba (em ordem visual):
 *
 *   1. `.main-header` com `.header-top-row` = ID (esq) + event-name/track
 *      (centro) + slot `[action-buttons]` (dir) + medidor oculto.
 *   2. `.status-stamp` (só quando `showStamp` — autor/revisor com submissão).
 *   3. Slot `[meta-card]` (chair/revisão projeta a barra sticky).
 *   4. `.main-title` = `<h1>` read-only OU slot `[title-edit]` em edit-mode.
 *
 * Medição de `.event-name-measure` (decide entre nome completo vs sigla)
 * PERMANECE no paper-info via `querySelector` — funciona porque
 * querySelector atravessa fronteiras de componentes e classes CSS não
 * dependem de scope Angular.
 */
@Component({
  selector: 'app-submission-header',
  templateUrl: './submission-header.component.html',
  styleUrls: ['./submission-header.component.scss'],
})
export class SubmissionHeaderComponent {
  /** Objeto completo da submissão. Lê `id`, `event.{name,acronym,year}`,
   *  `track?.name`, `title`, `status`. */
  @Input() submission!: Submission;
  /** true quando o event-name não cabe e usamos a sigla+ano no lugar.
   *  Setado pelo paper-info via `updateEventLabelFit()` (ResizeObserver). */
  @Input() useEventAcronym = false;
  /** Rótulo pronto da sigla ("SBRC 2025"). Precomputado no paper-info. */
  @Input() eventAcronymLabel = '';
  /** true na visão CHAIR — troca `<a>` do nome do evento por `<span>` (chair
   *  não navega). */
  @Input() isChairInterface = false;
  /** true quando exibir a segunda linha (nome da TRILHA). Só autor/revisor/
   *  session-chair têm essa linha. */
  @Input() showTrack = false;
  /** true quando o AUTOR pode trocar a track pela própria página (track atual
   *  aberta). Troca a linha da track de texto p/ `app-jems-select`. */
  @Input() canEditTrack = false;
  /** FormGroup com o control `track` — mesmo form usado pela meta-card do chair
   *  (`paper-info.submissionTrackForm`). */
  @Input() trackForm: FormGroup;
  /** Opções da track (mesma lista da meta-card, `paper-info.eventTrackList`). */
  @Input() trackOptions: any[] = [];
  /** Emitido quando o autor seleciona uma nova track — paper-info abre o
   *  `ChangeTracksDialogComponent` (mesmo fluxo do chair). */
  @Output() trackChange = new EventEmitter<void>();
  /** true no modo edição — esconde o `<h1>` read-only e projeta o slot
   *  `[title-edit]` no lugar. */
  @Input() isEditMode = false;
  /** true quando exibir o carimbo de status sobreposto à folha. Autor/revisor
   *  quando `isSubmission && !effectiveChair`. */
  @Input() showStamp = false;
  /** Linha "Trilha: X - Grupo: Y - TPC Group: Z" pro export chair. Renderiza
   *  no MESMO slot visual do `.event-track` (subtítulo centralizado abaixo
   *  do nome do evento). Substitui a meta-card interativa que é strippada
   *  no HTML exportado. Vazio em qualquer outro contexto. */
  @Input() chairMetaLine = '';
}
